export default "__VITE_ASSET__BIKLREqW__"